module.exports = __webpack_public_path__ + "img/COMBO RAINBOW GREEN.e48f770.svg";